export const backend = {
  api: "/api/",
  mediaPath: "/media/",
  key: "eKabd7G;bd",
  suffixSplitChars: ["%", ".", ","],
  httpAuth: {
    user: "porpoise",
    pass: "12india9",
  },
  checkMod: false,
  mode: "student",
};

export const baseUrl = "https://arca23upload.platform-3.co.uk";

export const localStoreEnabled = true;

export const azureLoginFirst = true;

export const testMode = false;

export const showModeToggle = false;

export const requireSponsorUrl = false;

export const thumbParams = {
  mode: "resize",
  width: 640,
  height: 2560,
};

export const featuredParams = {
  mode: "resize",
  width: 1920,
  height: 1234,
};

export const previewParams = {
  mode: "resize",
  width: 1920,
  height: 2560,
};

export const settings = {
  test_mode: false,
  submissions_deadline: "2022-06:09T00:00:00",
  dates: {
    full: "d MMMM yyyy",
    datetime: "dd/MM/yyyy HH:mm",
  },
  submissions_open: true,
  max_files_per_submission: 144,
  max_mediaitems_per_submission: 144,
  max_works_per_submission: 12,
  max_files_per_work: 12,
  max_tags_per_work: 4,
  max_uploaded_videos: 4,
  work_validation_rule: "media",
  min_image_size: [
    { key: "width", value: 800 },
    { key: "height", value: 800 },
  ],
  work_description_max_words: 800,
  max_stored_file_size_mb: 20,
  audio_file_max_duration: 7200,
  video_clip_max_duration: 7200,
  max_subthemes: 3,
};

export const validUploadTypes = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/svg+xml",
  "video/mp4",
];

export const statements = [
  {
    type: "biography",
    prompt: "About",
    imageType: "featured",
    imagePrompt: "Featured Image",
  },
  /*{
    type: "where_am_i",
    prompt: "Statement",
    imageType: "statement",
    imagePrompt: "Statement image",
  }*/,
];

export const retrieveImageMeta = false;

export const captureHashTags = false;

export const enableTextItem = true;

export const enableProfileTags = true;

export const enableContainerTags = backend.mode === "student";

export const customToolbar: Array<any> = [
  [{ header: [false, 2, 3, 4] }, "bold", "italic"],
  ["link"],
  ["blockquote", { list: "ordered" }, { list: "bullet" }, "rule", "clean"],
];

export const previewSite = {
  showButton: false,
  showLink: true,
  baseUri: "https://rca2020public-3221567115.gtsb.io/students/",
  postUri:
    "https://webhook.gatsbyjs.com/hooks/data_source/d1f05404-d364-44ad-bf98-5c6c118bf9a9",
};

export const mayRegister = false;

export const enableForgotten = false;

export const previewBaseUrl = "https://2022.rca.ac.uk/students";

export const msalRemote = {
  sha: "sha384-WV/465aYIrPn7bcKutSAFz+3JedxtCaRXxYu5EEjgGKPaOz7gjN06C8tBoGEmlZm",
  version: "2.20.0",
  regionDomain:"msftauth",
}

